import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/TorusGeometry'

export default meshComponent('Torus', props, createGeometry)
